import * as Constants from '../constants';

const initialState = {};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
  	case Constants.FETCH_ACTIVE_REFILL_START:
  	     return Object.assign({data: state.data,  action:action, loading: true});
    case Constants.FETCH_ACTIVE_REFILL_SUCCESS:
         return Object.assign({data: action.data,  action:action, loading: false});
    case Constants.FETCH_ACTIVE_REFILL_FAILURE: 
         return Object.assign({data: action.data, action:action, loading: false});
    default:
      return { ...state };
  }
}
